import CalculatorsController from '../../src/javascripts/cvm';
import FieldNationRoi from '../../src/javascripts/models/field_nation/roi';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
import '../../src/javascripts/helpers/application/hubspot_helpers';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/field_nation/calculated_fields';
import '../../src/stylesheets/field_nation/roi.scss';

(function() {
  $(() => CalculatorsController.run(new FieldNationRoi()));
}).call(this);

// Disable some inputs that are are view-only
$(() => {
  const calculated_fields = [
    '#annual-subscription-fee',
    '#incremental-opex-year1',
    '#incremental-opex-year2',
    '#incremental-opex-year3',
    '#total-annual-investment-for-fn',
    '#annual-field-service-revenue',
    '#pct-service-spend-on-field-nation',
    '#avg-cost-per-revisit'
  ];

  calculated_fields.forEach((field) => {
    $(field).attr('readOnly', true);
  });
});
